import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/toaster/showToast";
import { useDeleteRefundEntryInLedgerMutation } from "src/services/RefundBalanceService";
import DeleteRefundBalanceForm from "./DeleteRefundBalanceForm";

export type DistributorRefundDeleteValues = {
  otp: string;
};

type Props = {
  onClose: () => void;
  entryId: string;
  deleteAmount:string ;
};

const DeleteRefundBalanceFormWrapper = ({ onClose, entryId ,deleteAmount }: Props) => {
  const [deleteRefundEntry] = useDeleteRefundEntryInLedgerMutation();

  // Form Initial Values
  const initialValues: DistributorRefundDeleteValues = {
    otp: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    otp: string().required("Please enter otp"),
  });

  // Handle Submit
  const handleSubmit = (
    values: DistributorRefundDeleteValues,
    { setSubmitting, resetForm }: FormikHelpers<DistributorRefundDeleteValues>
  ) => {
    deleteRefundEntry({ id: entryId, body: values }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <DeleteRefundBalanceForm
              formikProps={formikProps}
              onClose={onClose}
              deleteAmount={deleteAmount}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default DeleteRefundBalanceFormWrapper;
